// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/report_attributes/salvar
 *
 * Returns the id of the inserted/updated report attribute.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Report_attributes_SalvarResponseDados {
so_ra_id: number
}

export type Report_attributes_SalvarResponse = ApiResponse<Report_attributes_SalvarResponseDados>;

registerResponseContract('Report_attributes_SalvarResponse', {
  so_ra_id: { type: 'number',  required: true },
})
